export default class extends Controller {
  static targets = ["typeSelect", "fieldsContainer", "weeklyFields", "biweeklyFields"]

  connect() {
    App.DynamicSelect.initEl(this.typeSelectTarget)
    App.DynamicSelect.onChange(this.typeSelectTarget, this.showAppropriateFields.bind(this))
    this.showAppropriateFields()
  }

  showAppropriateFields() {
    this.fieldsContainerTarget.innerHTML = this[`${this.typeText}FieldsTarget`].innerHTML
  }

  get typeText() {
    switch(this.type) {
      case "UserAvailabilities::WeeklyDefaultUserAvailability":
        return "weekly"
      case "UserAvailabilities::BiweeklyDefaultUserAvailability":
        return "biweekly"
    }
  }

  get type() {
    return App.DynamicSelect.getValue(this.typeSelectTarget)
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/defaultUserAvailabilities/default-user-availability-form-controller.js